import type { SmartCreationStrategyRecommendationEvidence } from "@adpilot/shared";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";

export function StrategyEvidenceDetails({
  evidence,
}: {
  evidence: SmartCreationStrategyRecommendationEvidence;
}) {
  const { t } = useTranslation("smartCreation");
  const statusVariant =
    evidence.status === "sufficient"
      ? "success"
      : evidence.status === "stale"
        ? "warning"
        : "neutral";
  return (
    <div className="text-xs">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h4 className="font-semibold text-ink">{t("strategy.evidence.title")}</h4>
        <Badge variant={statusVariant}>{t(`strategy.evidence.status.${evidence.status}`)}</Badge>
      </div>
      <p className="mt-2 leading-5 text-muted-foreground">
        {t(
          evidence.expanded
            ? "strategy.evidence.expandedWindow"
            : "strategy.evidence.primaryWindow",
          {
            actual: evidence.actualWindowDays,
            primary: evidence.primaryWindowDays,
            start: evidence.windowStart,
            end: evidence.windowEnd,
          },
        )}
      </p>
      <dl className="mt-3 space-y-2">
        <div className="flex justify-between gap-3">
          <dt className="text-muted-foreground">{t("strategy.evidence.searchTerms")}</dt>
          <dd className="font-mono font-medium">{evidence.sources.searchTerms.records}</dd>
        </div>
        <div className="flex justify-between gap-3">
          <dt className="text-muted-foreground">{t("strategy.evidence.targets")}</dt>
          <dd className="font-mono font-medium">{evidence.sources.targets.records}</dd>
        </div>
        <div className="flex justify-between gap-3">
          <dt className="text-muted-foreground">{t("strategy.evidence.products")}</dt>
          <dd className="font-mono font-medium">
            {evidence.matchedProducts}/{evidence.selectedProducts}
          </dd>
        </div>
        <div className="flex justify-between gap-3">
          <dt className="text-muted-foreground">{t("strategy.evidence.canonicalSource")}</dt>
          <dd className="text-right font-medium">
            {evidence.canonicalSource
              ? t(`strategy.editor.sources.${evidence.canonicalSource}`)
              : t("strategy.evidence.noCanonicalSource")}
          </dd>
        </div>
      </dl>
    </div>
  );
}
